<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » <a [href]="facilityLink">施設情報</a> » 本番反映の説明
  </div>
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>本番反映の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/reflect-data.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 閉じるボタン
        </div>
        <div class="manual-explain">
          クリックすることでダイアログを閉じます。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> 実行予約日時
        </div>
        <div class="manual-explain">
          本番反映を実行する日時を設定します。<br>
          ※本番反映を予約する場合は必須入力となります。また、過去の日時を設定することはできません。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> 本番反映情報
        </div>
        <div class="manual-explain">
          設定された本番反映予約日時、前回本番反映した日時、本番反映ステータスが表示されます。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> 予約ボタン
        </div>
        <div class="manual-explain">
          クリックすることで本番反映を予約します。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> 予約取消ボタン
        </div>
        <div class="manual-explain">
          クリックすることで設定した実行予約日時を取り消します。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> 即時実行ボタン
        </div>
        <div class="manual-explain">
          クリックすることで即時に本番反映処理を実行します。
        </div>

      </mat-card-content>
    </mat-card>
  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » <a [href]="facilityLink">Facility Information</a> » Explanation of Live Environment Deployment
  </div>
  
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
  
    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Live Environment Deployment</span></mat-card-title>
      </mat-card-header>
  
      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_reflect-data.png" width="100%">
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Close Button
        </div>
        <div class="manual-explain">
          Clicking this button will close the dialog.<br>
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Scheduled Execution Date and Time
        </div>
        <div class="manual-explain">
          Set the date and time for deploying to the live environment.<br>
          * This is required when scheduling a deployment. Past dates and times cannot be set.<br>
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Deployment Information
        </div>
        <div class="manual-explain">
          Displays the scheduled deployment date and time, the last deployment date and time, and the current deployment status.<br>
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Schedule Button
        </div>
        <div class="manual-explain">
          Clicking this button will schedule the deployment.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> Cancel Schedule Button
        </div>
        <div class="manual-explain">
          Clicking this button will cancel the scheduled execution date and time.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> Execute Immediately Button
        </div>
        <div class="manual-explain">
          Clicking this button will immediately execute the deployment process.
        </div>
  
      </mat-card-content>
    </mat-card>
  
  </div>  
</div>
